import { render } from "./BlockedContentNotice.vue?vue&type=template&id=48009881&scoped=true"
import script from "./BlockedContentNotice.vue?vue&type=script&lang=js"
export * from "./BlockedContentNotice.vue?vue&type=script&lang=js"

import "./BlockedContentNotice.vue?vue&type=style&index=0&id=48009881&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48009881"]])

export default __exports__